import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/modalidade?${serialize(filtros)}`, { tela: 'modalidade' })
}

export async function get (id) {
  return httpAuth.get(`/modalidade/${id}`, { tela: 'modalidade' })
}

export async function add (dados) {
  return httpAuth.post(`/modalidade`, dados, { funcionalidade: 'modalidade_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/modalidade/${id}`, dados, { funcionalidade: 'modalidade_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/modalidade/${id}`, { funcionalidade: 'modalidade_excluir' })
}
